var _rect, _path, _path2, _path3, _path4, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPubicTransport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 14,
    height: 13,
    rx: 1,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7213 12.5C11.9975 12.5 12.2213 12.2761 12.2213 12C12.2213 11.7239 11.9975 11.5 11.7213 11.5V12.5ZM5.5 11.5C5.22386 11.5 5 11.7239 5 12C5 12.2761 5.22386 12.5 5.5 12.5V11.5ZM19 12.5C19.2761 12.5 19.5 12.2761 19.5 12C19.5 11.7239 19.2761 11.5 19 11.5V12.5ZM11.7213 11.5H5.5V12.5H11.7213V11.5ZM5.5 12.5H19V11.5H5.5V12.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15811 6.52566C8.89614 6.43833 8.61298 6.57991 8.52566 6.84189C8.43833 7.10386 8.57991 7.38702 8.84189 7.47434L9.15811 6.52566ZM14.8419 9.47434C15.1039 9.56167 15.387 9.42009 15.4743 9.15811C15.5617 8.89614 15.4201 8.61298 15.1581 8.52566L14.8419 9.47434ZM8.84189 7.47434L14.8419 9.47434L15.1581 8.52566L9.15811 6.52566L8.84189 7.47434Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69275 18V17.5H8.50437L8.36283 17.6243L8.69275 18ZM15.4887 18L15.8247 17.6297L15.6817 17.5H15.4887V18ZM4.37711 21.1243C4.16962 21.3065 4.14912 21.6224 4.33133 21.8299C4.51354 22.0374 4.82945 22.0579 5.03695 21.8757L4.37711 21.1243ZM19.0098 21.8703C19.2143 22.0558 19.5305 22.0405 19.7161 21.836C19.9017 21.6315 19.8863 21.3153 19.6818 21.1297L19.0098 21.8703ZM8.69275 18.5H15.4887V17.5H8.69275V18.5ZM5.03695 21.8757L9.02266 18.3757L8.36283 17.6243L4.37711 21.1243L5.03695 21.8757ZM15.1527 18.3703L19.0098 21.8703L19.6818 21.1297L15.8247 17.6297L15.1527 18.3703Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 20H17.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 15,
    r: 1,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 1,
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPubicTransport);
export default __webpack_public_path__ + "static/media/pubic_transport.630920e18144605a1c757b89a9349cb9.svg";
export { ForwardRef as ReactComponent };